'use strict';

const sectionScroller = require('../../sectionScroller');
const isMobileOrTabletWidth = require('../../modules/util/isMobileOrTabletWidth');

function initEvents(context) {
    // init general events
    context.customiseButton.off('click.personalise').on('click.personalise', function (e) {
        e.preventDefault();
        if (isMobileOrTabletWidth()) {
            sectionScroller.scrollToCustom($('.js-custom-giftset'));
            return;
        }
        sectionScroller.scrollTo($('.js-custom-giftset'));
    });

    context.goToCardButton.off('click.personalise').on('click.personalise', function () {
        sectionScroller.scrollTo($('.js-write-a-card-block'));
    });

    context.readMoreLink.off('click.readmore').on('click.readmore', function () {
        if (!isMobileOrTabletWidth()) {
            sectionScroller.scrollWithOffset($('.js-product-tabs'));
        }
    });
}

function handleScrollingInEditMode(context) {
    if (!context.editModeIndicator.val()) {
        return;
    }
    context.customiseButton.click();
}

const personalise = {
    customiseButton: $('.js-go-to-customise-set'),
    goToCardButton: $('.js-go-to-write-card'),
    editModeIndicator : $('.js-edit-mode-indicator'),
    readMoreLink : $('.js-read-more-link-pg'),
    init: function() {
        initEvents(this);
        handleScrollingInEditMode(this);
    }
};

module.exports = personalise;
